import styled from 'styled-components';

export const boxCopyright = styled.div`
  background: #ffffff;
  padding-top: 20px;
  margin-top: 20px;
`;
